import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { BOOK_TITLE, KINDLE_SELECT_MODE } from '../../lib/constants';

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-bg/95 backdrop-blur-sm border-b border-sage/10">
      <nav className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="font-serif text-lg font-semibold text-text hover:text-sage-dark transition-colors">
          {BOOK_TITLE}
        </Link>

        {/* Desktop nav */}
        <div className="hidden sm:flex items-center gap-6">
          <a
            href="#pricing"
            className="text-sm text-text-light hover:text-sage-dark transition-colors"
          >
            Buy Now
          </a>
          {!KINDLE_SELECT_MODE && (
            <Link
              to="/redeem"
              className="text-sm text-text-light hover:text-sage-dark transition-colors"
            >
              Redeem Code
            </Link>
          )}
          <a
            href="#pricing"
            className="inline-flex items-center px-4 py-2 rounded-lg bg-sage text-white text-sm font-medium hover:bg-sage-dark transition-colors"
          >
            Get the Book
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          className="sm:hidden p-2 text-text-light"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        >
          <svg aria-hidden="true" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </nav>

      {/* Mobile menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="sm:hidden overflow-hidden border-b border-sage/10"
          >
            <div className="px-4 py-4 space-y-3">
              {/* biome-ignore lint/a11y/useValidAnchor: real in-page navigation to #pricing (browser hash-scrolls); the onClick only closes the mobile menu and never prevents default. Converting to a button would require re-implementing scroll-to-anchor behavior in JS, which would change runtime behavior. */}
              <a
                href="#pricing"
                className="block text-text-light hover:text-sage-dark transition-colors"
                onClick={() => setMenuOpen(false)}
              >
                Buy Now
              </a>
              {!KINDLE_SELECT_MODE && (
                <Link
                  to="/redeem"
                  className="block text-text-light hover:text-sage-dark transition-colors"
                  onClick={() => setMenuOpen(false)}
                >
                  Redeem Code
                </Link>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
